import usePrivateAxios from "@/common/api/usePrivateAxios"
import { useMutation } from "@tanstack/react-query"
import { MaintenanceSpecialtyValidationSchema } from "../../schemas/maintenanceSpecialty.schema"

interface UseCreateEstablishmentLeadMaintenanceSpecialtyProps {
  id?: string
  onSuccess?: () => void
  onError?: (error: any) => void
}

export const useCreateEstablishmentLeadMaintenanceSpecialty = ({
  id,
  onSuccess,
  onError,
}: UseCreateEstablishmentLeadMaintenanceSpecialtyProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['createEstablishmentLeadMaintenanceSpecialty'],
    mutationFn: (data: MaintenanceSpecialtyValidationSchema) => {
      const payload = {
        maintenance_specialty_attributes: {
          system_part_id: data.system_part?.value,
          action_id: data.action?.value,
        },
      }

      return privateAxios.put(`/funnel/establishment/leads/${id}/update_maintenance_models`, {
        lead: payload,
      })
    },
    onSuccess,
    onError,
  })
}
